/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonWithZugaengeDto } from '../../models/person-with-zugaenge-dto';
import { UpdatePersonenWithZugaengeDto } from '../../models/update-personen-with-zugaenge-dto';

export interface UpdatePersonenWithZugaenge$Plain$Params {

/**
 * ID des Mitarbeiters der eingeloggt ist und das Update startet
 */
  updaterId?: string;
  
    /**
     * Werte mit denen aktualisiert wird
     */
    body?: Array<UpdatePersonenWithZugaengeDto>
}

export function updatePersonenWithZugaenge$Plain(http: HttpClient, rootUrl: string, params?: UpdatePersonenWithZugaenge$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PersonWithZugaengeDto>>> {
  const rb = new RequestBuilder(rootUrl, updatePersonenWithZugaenge$Plain.PATH, 'put');
  if (params) {
    rb.query('updaterId', params.updaterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PersonWithZugaengeDto>>;
    })
  );
}

updatePersonenWithZugaenge$Plain.PATH = '/v1/personzugaenge/updatepersonenwithzugaenge';
